import React, { Component } from 'react';

class CompaniesCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
      isTransitioning: true,
      companies: [
        {
          id: 1,
          name: 'OdeaoLabs',
          logo: '../images/buildit.png'
        },
        {
          id: 2,
          name: 'Kintsugi',
          logo: '../images/chandos.png'
        },
        {
          id: 3,
          name: 'StackEd Lab',
          logo: '../images/ellisdon.png'
        },
        {
          id: 4,
          name: 'Magnolia',
          logo: '../images/fortis.png'
        },
        {
          id: 5,
          name: 'Warpspeed',
          logo: '../images/Graham-Logo-with-Red-Parallelogram2.png'
        },
        {
          id: 6,
          name: 'Sisyphus',
          logo: '../images/jb.png'
        },
        {
          id: 7,
          name: 'TechCorp',
          logo: '../images/john.png'
        },
        {
          id: 8,
          name: 'InnovateLab',
          logo: '../images/mac.png'
        },
        {
          id: 9,
          name: 'Warpspeed',
          logo: '../images/ooe.png'
        },
        {
          id: 10,
          name: 'Sisyphus',
          logo: '../images/west.png'
        },
        {
          id: 11,
          name: 'TechCorp',
          logo: '../images/Intelligent-Real-Estate-Investments-at-Hines.svg'
        },
        {
          id: 12,
          name: 'InnovateLab',
          logo: '../images/mat.png'
        },
        {
          id: 13,
          name: 'InnovateLab',
          logo: '../images/shane.png'
        }
      ]
    };
    this.carouselInterval = null;
  }

  componentDidMount() {
    this.startCarousel();
  }

  componentWillUnmount() {
    this.stopCarousel();
  }

  startCarousel = () => {
    this.carouselInterval = setInterval(() => {
      this.nextSlide();
    }, 3000); // Change slide every 3 seconds
  };

  stopCarousel = () => {
    if (this.carouselInterval) {
      clearInterval(this.carouselInterval);
    }
  };

  nextSlide = () => {
    const { companies, currentIndex } = this.state;
    const nextIndex = (currentIndex + 1) % companies.length;
    
    this.setState({
      currentIndex: nextIndex
    });
  };

  prevSlide = () => {
    const { companies, currentIndex } = this.state;
    const prevIndex = currentIndex === 0 ? companies.length - 1 : currentIndex - 1;
    
    this.setState({
      currentIndex: prevIndex
    });
  };

  goToSlide = (index) => {
    this.setState({
      currentIndex: index
    });
  };

  handleMouseEnter = () => {
    this.stopCarousel();
  };

  handleMouseLeave = () => {
    this.startCarousel();
  };

  // Get visible companies (current + next 2 for desktop view)
  getVisibleCompanies = () => {
    const { companies, currentIndex } = this.state;
    const visibleCompanies = [];
    
    for (let i = 0; i < 6; i++) {
      const index = (currentIndex + i) % companies.length;
      visibleCompanies.push(companies[index]);
    }
    
    return visibleCompanies;
  };

  render() {
    const { companies, currentIndex } = this.state;
    const visibleCompanies = this.getVisibleCompanies();

    const styles = {
      carouselContainer: {
        // background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
        overflow: 'hidden',
        position: 'relative'
      },
      carouselTrack: {
        display: 'flex',
        transition: 'transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        gap: '2rem'
      },
      companyCard: {
        minWidth: '135px',
        height: '120px',
        // background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(10px)',
        // border: '1px solid rgba(255, 255, 255, 0.1)',
        // borderRadius: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // padding: '1rem',
        transition: 'all 0.4s ease',
        cursor: 'pointer',
        position: 'relative',
        overflow: 'hidden'
      },
      companyCardHover: {
        transform: 'translateY(-8px) scale(1.02)',
        background: 'rgba(255, 255, 255, 0.08)',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3), 0 0 20px rgba(59, 130, 246, 0.2)'
      },
      companyLogo: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        filter: 'brightness(0.9) contrast(1.1)',
        transition: 'all 0.3s ease'
      },
      indicator: {
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        background: 'rgba(255, 255, 255, 0.3)',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        margin: '0 4px'
      },
      activeIndicator: {
        background: '#3b82f6',
        transform: 'scale(1.2)',
        boxShadow: '0 0 10px rgba(59, 130, 246, 0.5)'
      },
      gradientOverlay: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        width: '100px',
        pointerEvents: 'none',
        zIndex: 2
      },
      leftGradient: {
        left: 0,
        
        background: 'linear-gradient(90deg, var(--primary-dark) 0%, transparent 100%)'
      },
      rightGradient: {
        right: 0,
        background: 'linear-gradient(270deg, var(--primary-dark) 0%, transparent 100%)'
      }
    };

    return (
      <section className="py-5" style={styles.carouselContainer}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <p className="text-white mb-2" style={{ 
                fontSize: '16px', 
                fontWeight: '400',
                opacity: 0.8
              }}>
                Trusted by industry leaders
              </p>
              <h3 className="text-white mb-4" style={{ 
                fontSize: '28px', 
                fontWeight: '700',
                background: 'linear-gradient(135deg, #ffffff 0%, #94a3b8 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                Join 100+ companies already growing
              </h3>
            </div>
          </div>
          
          {/* Carousel Container */}
          <div className="row">
            <div className="col-12">
              <div 
                className="position-relative"
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
                style={{ padding: '0 2rem' }}
              >
                {/* Gradient Overlays */}
                <div style={{...styles.gradientOverlay, ...styles.leftGradient}}></div>
                <div style={{...styles.gradientOverlay, ...styles.rightGradient}}></div>
                
                {/* Carousel Track */}
                <div className="d-flex justify-content-center overflow-hidden">
                  <div 
                  className='eachSlide'
                    style={{
                      ...styles.carouselTrack,
                      transform: `translateX(-${currentIndex * 135}px)`
                    }}
                  >
                    {/* Render all companies in a continuous loop */}
                    {[...companies, ...companies].map((company, index) => (
                      <CompanyCard 
                        key={`${company.id}-${index}`}
                        company={company}
                        styles={styles}
                        onClick={() => this.goToSlide(index % companies.length)}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Carousel Indicators */}
          <div className="row mt-4">
            <div className="col-12 d-flex justify-content-center align-items-center">
              {companies.map((_, index) => (
                <div
                  key={index}
                  style={{
                    ...styles.indicator,
                    ...(index === currentIndex ? styles.activeIndicator : {})
                  }}
                  onClick={() => this.goToSlide(index)}
                />
              ))}
            </div>
          </div>

          {/* Carousel Controls */}
          <div className="row mt-3">
            <div className="col-12 d-flex justify-content-center gap-3">
              <button
                onClick={this.prevSlide}
                className="btn d-flex align-items-center justify-content-center"
                style={{
                  width: '48px',
                  height: '48px',
                  background: 'rgba(255, 255, 255, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: '12px',
                  color: 'white',
                  backdropFilter: 'blur(10px)',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                  e.target.style.transform = 'scale(1.05)';
                }}
                onMouseOut={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                &#8249;
              </button>
              
              <button
                onClick={this.nextSlide}
                className="btn d-flex align-items-center justify-content-center"
                style={{
                  width: '48px',
                  height: '48px',
                  background: 'rgba(255, 255, 255, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: '12px',
                  color: 'white',
                  backdropFilter: 'blur(10px)',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                  e.target.style.transform = 'scale(1.05)';
                }}
                onMouseOut={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                &#8250;
              </button>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

// Company Card Component
class CompanyCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false
    };
  }

  render() {
    const { company, styles, onClick } = this.props;
    const { isHovered } = this.state;

    return (
      <div
      className='eachbox'
        style={{
          ...styles.companyCard,
          ...(isHovered ? styles.companyCardHover : {})
        }}
        onMouseEnter={() => this.setState({ isHovered: true })}
        onMouseLeave={() => this.setState({ isHovered: false })}
        onClick={onClick}
      >
        {/* Shimmer Effect */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: '-100%',
            width: '100%',
            height: '100%',
            background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.2) 50%, transparent 100%)',
            animation: isHovered ? 'shimmer 1.5s ease-in-out' : 'none'
          }}
        />
        
        <img
          src={company.logo}
          alt={`${company.name} logo`}
          style={{
            ...styles.companyLogo,
            ...(isHovered ? { filter: 'brightness(1.1) contrast(1.2)' } : {})
          }}
          onError={(e) => {
            // Fallback to a placeholder or company name
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'block';
          }}
        />
        
        <div
          style={{
            display: 'none',
            color: 'white',
            fontSize: '18px',
            fontWeight: '600',
            textAlign: 'center'
          }}
        >
          {company.name}
        </div>
      </div>
    );
  }
}

// Add CSS animation for shimmer effect
const shimmerStyle = document.createElement('style');
shimmerStyle.textContent = `
  @keyframes shimmer {
    0% { left: -100%; }
    100% { left: 100%; }
  }
`;
document.head.appendChild(shimmerStyle);

export default CompaniesCarousel;